import { DashboardPlugin } from "../../../core/plugin/PluginType";
import PendingApprovalsWidget from "./PendingApprovalsWidget";

const PendingApprovalsDashboardPlugin: DashboardPlugin = {
    id: 'pending-approvals-widget',
    name: 'Ausstehende Freigaben',
    icon: 'clipboardCheck',
    version: '1.0.0',
    description: 'Displays approval instances waiting for action by the current user',
    author: 'Your Company',
    type: 'dashboard',
    component: PendingApprovalsWidget,
    defaultSize: 'medium',
    defaultPreferences: {},
    isPinned: true,
    requiredPermissions: ['dashboard.plugins.pending-approvals.view'],
};

export default PendingApprovalsDashboardPlugin;